module.exports = __webpack_public_path__ + "static/media/SCBsecurityMobile.f6661228.svg";